<template lang="pug">
    v-container(grid-list-md v-if="content" )
        v-layout(wrap)
            v-flex(lg6 md6 xs12)
                v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                    template(v-slot:prepend)
                        v-icon(color="warning") mdi-credit-card-multiple-outline
            v-flex(lg5 md5 xs12)
                v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg6 md6 xs12 v-if="content.note")
                v-text-field(dense v-model="content.note" label="Berita" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg5 md5 xs12 v-if="content.customerRef")
                v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                    template(v-slot:prepend)
                        v-icon(color="primary") mdi-note-text-outline
            v-flex(lg12 md12 xs12)
                v-layout(wrap)
                    v-flex(lg6 md6 xs12)
                        v-text-field(dense v-model="destination" label="No Rekening Tujuan" readonly)
                            template(v-slot:prepend)
                                v-icon(color="success") mdi-credit-card-multiple-outline
                    v-flex(lg5 md5 xs12)
                        v-text-field(dense v-if="request" v-model="bank" label="Bank Tujuan" readonly)
                            template(v-slot:prepend)
                                v-icon(color="primary") mdi-checkbox-marked-outline
            v-flex(lg12 md12 xs12)
                v-layout(wrap)
                    v-flex(lg3 md3 xs12)
                        f-decimalbox(v-model="content.summary.amount" label="Nominal" readonly :template="true")
                    v-flex(lg2 md2 xs12)
                        f-decimalbox(v-model="content.summary.fee" label="Biaya Admin" readonly :template="true")
                    v-flex(lg3 md3 xs12)
                        f-decimalbox(v-model="content.summary.totalAmount" label="Total" readonly :template="true")
                
</template>
<script>
export default {
  name: "FTransferOnlineContent",
  props: ["content", "request", "transaction"],
  computed: {
    source() {
      return this.$options.filters.accountformat(this.content.source)+ " - " + this.content.sourceName;
    },
    destination() {
      return this.$options.filters.accountformat(this.content.dest.account) + " - " + this.content.dest.name;
    },
    bank() {
      return this.request.data.bankCode + " - " + this.request.data.bankName;
    }
  }
};
</script>